module.exports = __webpack_public_path__ + "img/thumbnail-foodlab-motion.44c00a9.jpg";